import classes from "./Item.module.css";
import QRCodeKind from "../../../../api/qr-code/QRCodeKind";
import {useContext} from "react";
import CreateQRCodeContext from "../CreateQRCodeContext";
import {IconId} from "@tabler/icons-react";

type ItemProps = {
    /**
     * Kind to be set in context.
     * @author Kacper Faber
     * @since 0.1.8
     */
    kind: QRCodeKind | null;

    /**
     * Label to display.
     * @author Kacper Faber
     * @since 0.1.8
     */
    label: string;

    description?: string;
};

/**
 * Selectable list item represents QRCodeKind we can pick.
 * Actually does not support highlighting.
 * Must be in CreateQRCodeContext.
 * @author Kacper Faber
 * @since 0.1.8
 * @param props
 * @constructor
 */
function Item(props: ItemProps) {
    /**
     * Create QR code context.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(CreateQRCodeContext);

    /**
     * On item is clicked.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const onItemClicked = () => {
        if (ctx.kind == props.kind) {
            ctx.setKind(null);
            return;
        }

        ctx.setKind(props.kind);
    };

    /**
     * Check if current item is active.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const isActive = () => {
        return ctx.kind === props.kind;
    }

    /**
     * Combine .root and .active/.inactive.
     * @author Kacper Faber
     * @since 0.1.8
     */
    const getRootClasses = () => {
        return `${classes.root} ${isActive() ? classes.active : classes.inactive}`;
    }

    return (
        <div className={getRootClasses()} onClick={onItemClicked}>
            <div className={classes.left}>
                <IconId
                    size={38}
                    className={classes.iconLeft}
                    color="var(--mantine-color-dimmed)"
                />
            </div>

            <div className={classes.right}>
                <div className={classes.title}>{props.label}</div>
                <div className={classes.description}>
                    { props.description }
                </div>
            </div>
        </div>
    );
}

export default Item;